var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 154,
    transform: "translate(0.667969 0.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4556:50089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.8 10C109 10 109.3 10.1 109.5 10.2C109.7 10.4 109.9 10.6 110.1 10.9C110.3 11.2 110.4 11.5 110.5 11.9C110.6 12.3 110.6 12.7 110.6 13.1V141C110.6 141.4 110.5 141.8 110.5 142.2C110.4 142.6 110.3 142.9 110.1 143.2C109.9 143.5 109.7 143.7 109.5 143.9C109.3 144.1 109 144.1 108.8 144.1H99.2C99 144.1 98.7 144 98.5 143.9C98.3 143.7 98.1 143.5 97.9 143.2C97.7 142.9 97.6 142.6 97.5 142.2C97.4 141.8 97.4 141.4 97.4 141V122.8H89.5V141C89.5 141.4 89.4 141.8 89.4 142.2C89.3 142.6 89.2 142.9 89 143.2C88.8 143.5 88.6 143.7 88.4 143.9C88.2 144.1 87.9 144.1 87.7 144.1H46.9C46.7 144.1 46.4 144 46.2 143.9C46 143.7 45.8 143.5 45.6 143.2C45.4 142.9 45.3 142.6 45.2 142.2C45.1 141.8 45 141.4 45 141V13.1C45 12.7 45.1 12.3 45.1 11.9C45.2 11.5 45.3 11.2 45.5 10.9C45.7 10.6 45.9 10.4 46.1 10.2C46.4 10.1 46.6 10 46.9 10H108.8Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.1 13.8H49V144.2H85.9V124.7C85.9 124.3 86 123.8 86 123.4C86.1 123 86.2 122.6 86.4 122.3C86.6 122 86.8 121.8 87 121.6C87.2 121.4 87.5 121.3 87.7 121.3H99.4C99.6 121.3 99.9 121.4 100.1 121.6C100.3 121.8 100.5 122 100.7 122.3C100.9 122.6 101 123 101.1 123.4C101.2 123.8 101.2 124.3 101.2 124.7V144.2H107V13.8H107.1Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 18.1001H74.5977V23.9001H81.1977V18.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 18.1001H55.6992V23.9001H62.2992V18.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 18.1001H93.3984V23.9001H99.9984V18.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 89.9001H74.5977V95.7001H81.1977V89.9001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 89.9001H55.6992V95.7001H62.2992V89.9001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 89.9001H93.3984V95.7001H99.9984V89.9001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 107.9H74.5977V113.7H81.1977V107.9Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 107.9H55.6992V113.7H62.2992V107.9Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 107.9H93.3984V113.7H99.9984V107.9Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 36.1001H74.5977V41.9001H81.1977V36.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 36.1001H55.6992V41.9001H62.2992V36.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 36.1001H93.3984V41.9001H99.9984V36.1001Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 54H74.5977V59.8H81.1977V54Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 54H55.6992V59.8H62.2992V54Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 54H93.3984V59.8H99.9984V54Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1977 72H74.5977V77.8H81.1977V72Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2992 72H55.6992V77.8H62.2992V72Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9984 72H93.3984V77.8H99.9984V72Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.4 144.2H87.2C87.1 144.2 87 144.1 87 144V121.2C87 121.1 87.1 121 87.2 121H100.4C100.5 121 100.6 121.1 100.6 121.2V144C100.6 144.1 100.5 144.2 100.4 144.2Z",
    fill: "#02475E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4556:50089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.7,
    height: 134.2,
    fill: "white",
    transform: "translate(45 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingOnly);
export default __webpack_public_path__ + "static/media/BuildingOnly.a37da76b34d1d1a50dbc79f70db949dc.svg";
export { ForwardRef as ReactComponent };